(function($) {

  const resourceWrapper = document.querySelector('.page-template-resources #wpas-results');
  const lightboxWrapper = document.querySelector('.lightbox__wrapper');
  const lightboxContent = document.querySelector('.lightbox__content--inner');
  const lightboxClose = document.querySelector('.lightbox__close');

  function showVideo(event) {
    let link;

    if(event.target && event.target.matches('a[data-video]')) {
      link = event.target;
    } else if(event.target && event.target.parentElement.matches('a[data-video]')) {
      link = event.target.parentElement;
    }

    if(link && link.dataset.video) {
      event.preventDefault();
      const videoID = link.dataset.video;

      const embedCode = `<div class="video-container"><iframe width="560" height="315" src="https://www.youtube.com/embed/${videoID}?rel=0&amp;controls=0&amp;showinfo=0" frameborder="0" allowfullscreen></iframe></div>`;

      openLightbox(embedCode);
    }
  }

  function openLightbox(content) {
    lightboxWrapper.classList.add('display');
    lightboxContent.innerHTML = content;
  }

  function closeLightbox(event) {
    event.preventDefault();
    lightboxWrapper.classList.remove('display');
  }

  if(resourceWrapper) {
    resourceWrapper.addEventListener('click', showVideo);
  }

  if(lightboxClose) {
    lightboxClose.addEventListener('click', closeLightbox);
  }
  
}(jQuery));
